import { createApp } from 'vue'
import App from './App.vue' 
import router from './router'
import './assets/css/mobile.css'


createApp(App).use(router).mount('#app');

const userName = localStorage.getItem('user_name');
const userId =  localStorage.getItem('azure_id');

window.dataLayer.push({
  'event': 'login',
  'userId': userId //this number must be replaced with an actual User ID
})
